"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
const icf_platform_client_1 = require("@atg/icf-platform-client");
const Explicit_1 = __importDefault(require("@atg/icf-react-components/components/Explicit"));
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const translations_json_1 = __importDefault(require("./translations.json"));
/**
 * Shows explicit content only after the user has confirmed their age
 * See it in action: https://icfreactcomponents.integ.icfsys.com/#/Components/Explicit
 */
const Explicit = ({ children, explicit, ...props }) => {
    const [confirmed, setConfirmed] = (0, icf_platform_client_1.useAgeConfirmation)();
    const theme = (0, react_jss_1.useTheme)();
    const translations = translations_json_1.default;
    const translation = translations[theme.language] ?? translations.en;
    if (!explicit) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return (react_1.default.createElement(Explicit_1.default, { show: confirmed, onConfirm: () => setConfirmed(true), translation: translation, ...props }, children));
};
exports.default = Explicit;
